{
  "it": {
    "sublines": {
      "impressum": {
        "general": "Informazioni generali (ai sensi del § 5 TMG)",
        "disclaimer": "Disclaimer",
        "copyright": "Copyright",
        "thirdpartycontent": "Crediti",
        "sponsors": "Sponsor",
        "liabilityInternal": "Limitazione della responsabilità per il contenuto interno",
        "liabilityExternal": "Limitazione della responsabilità per i collegamenti esterni"
      }
    }
  }
}
